import { Combobox, Option } from "@fluentui/react-components";
import { useItemQuery } from "../../../shared/hooks/useItemQuery";
import { readUsers } from "../services/userApi";

export default function UsersComboBox({ value, onOptionSelect }) {
  const { data: users = [], isLoading } = useItemQuery(["users_summary"], readUsers, true);

  // Find the name that corresponds to the selected ID
  const selectedUser = users.find((u) => u.id === value);
  const selectedName = selectedUser ? `${selectedUser.fname} ${selectedUser.lname}` : "";

  const handleSelect = (_, data) => {
    if (!data) return;
    const selected = data.optionValue;
    const matched = users.find((u) => `${u.name}` === selected);
    console.log(`New user ${matched.id}`);
    onOptionSelect?.(matched?.id ?? null); // pass back the ID
  };

  return (
    <Combobox
      value={selectedName}
      onOptionSelect={handleSelect}
      placeholder={isLoading ? "Loading users..." : "Select a user"}
    >
      {users.map((u) => (
        <Option key={u.id} value={`${u?.name}`}>
          {`${u?.name}`}
        </Option>
      ))}
    </Combobox>
  );
}
